module.exports = __webpack_public_path__ + "img/More.347eae1d.svg";